import { createFileRoute } from "@tanstack/react-router";

import { OVERVIEW_QUERY } from "@/features/overview/graphql/overview-query";
import { Overview } from "@/features/overview/overview";

export const Route = createFileRoute("/_authenticated/")({
  component: Overview,
  loader: async ({ context }) => {
    if (context.urqlClient) {
      await context.urqlClient.query(OVERVIEW_QUERY, {}).toPromise();
    }
  },
});
